







































































































































































































































































import Vue from "vue";
import EditSelection from "@/components/end_parts/EditSelection.vue";
import EditSelectionBox from "@/components/end_parts/EditSelectionBox.vue";
import EditDMSBox from "@/components/end_parts/EditDMSBox.vue";
import EditNumberBox from "@/components/end_parts/EditNumberBox.vue";
import EditEpsg from "@/components/end_parts/EditEpsg.vue";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);

export default Vue.extend({
  components: {
    EditSelection,
    EditSelectionBox,
    EditNumberBox,
    EditDMSBox,
    EditEpsg,
  },
  props: {
    //Optsparam.vueから送られてくるopts.jsonのパラメータ
    projectionParam: {
      type: Object,
      default: Object,
    },
    //Optsparam.vueから送られてくるopts.jsonのキー
    projectionKey: {
      type: String,
      default: String,
    },
    //Optsparam.vueから送られてくるproj_param.jsonのパラメータ
    projectionProjParam: {
      type: Object,
      default: Object,
    },
    changeKei: {
      type: String,
      default: String,
    },
    changeZone: {
      type: String,
      default: String,
    },
    changeTerr: {
      type: String,
      default: String,
    },
  },
  data() {
    return {
      setting: true,
      checkRadio: "public",
      aaaaa: true,
      validateError: [
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
      ],
      errorProjection: true,
      column: {
        padding: "5px",
        margin: "0px -15px",
        "border-right": "solid 1px #DDDDDD",
        "border-bottom": "solid 1px #DDDDDD",
        "border-left": "solid 1px #DDDDDD",
      },
      columnInterTop: {
        padding: "5px",
        "border-top": "solid 1px #DDDDDD",
        "border-right": "solid 1px #DDDDDD",
        "border-bottom": "solid 1px #DDDDDD",
        "border-left": "solid 1px #DDDDDD",
      },
      columnInter: {
        padding: "5px",
        "border-top": "solid 1px #DDDDDD",
        "border-right": "solid 1px #DDDDDD",
        "border-bottom": "solid 1px #DDDDDD",
        "border-left": "solid 1px #DDDDDD",
      },
      columnSide: {
        padding: "5px",
        "border-right": "solid 1px #DDDDDD",
        "border-left": "solid 1px #DDDDDD",
      },
      columnInterCoordinate: {
        padding: "5px",
        margin: "0px 0px",
        "border-right": "solid 1px #DDDDDD",
        "border-bottom": "solid 1px #DDDDDD",
        "border-left": "solid 1px #DDDDDD",
      },
    };
  },
  watch: {
    changeKei() {
      this.changeKeiParam();
    },
    changeZone() {
      this.changeZoneParam();
    },
    changeTerr() {
      this.changeTerrParam();
    },
    checkRadio() {
      if (this.checkRadio === "public") {
        this.aaaaa = true;
      }
      if (this.checkRadio === "tm") {
        this.aaaaa = false;
      }
    },
    projectionParam: {
      handler() {
        if (this.projectionParam[this.projectionKey].map === "utm") {
          this.changeZoneParam();
        }
        // this.reload()
      },
      deep: true,
    },
  },
  created() {
    if (this.$store.state.inputFile.name === undefined) {
      this.changeTerrParam();
    }
  },
  methods: {
    // reload() {
    //   if (this.projectionParam[this.projectionKey].map === "tm") {
    //     this.projectionParam[
    //       this.projectionKey
    //     ].origin = this.projectionProjParam[
    //       this.projectionParam.projection.kei
    //     ].origin;
    //     this.projectionParam[
    //       this.projectionKey
    //     ].scale = this.projectionProjParam[
    //       this.projectionParam.projection.kei
    //     ].scale;
    //     this.projectionParam[this.projectionKey][
    //       "false_ne"
    //     ] = this.projectionProjParam[this.projectionParam.projection.kei][
    //       "false_ne"
    //     ];
    //   }
    //   if (this.projectionParam[this.projectionKey].map === "utm") {
    //     this.projectionParam[
    //       this.projectionKey
    //     ].origin = this.projectionProjParam[
    //       this.projectionParam.projection.zone
    //     ].origin;
    //     this.projectionParam[
    //       this.projectionKey
    //     ].scale = this.projectionProjParam[
    //       this.projectionParam.projection.zone
    //     ].scale;
    //     this.projectionParam[this.projectionKey][
    //       "false_ne"
    //     ] = this.projectionProjParam[this.projectionParam.projection.zone][
    //       "false_ne"
    //     ];
    //   }
    // },
    Run() {
      if (this.projectionParam[this.projectionKey].map === "utm") {
        return;
      }
      if (this.projectionParam[this.projectionKey].map === "mercator") {
        return;
      }
      if (this.projectionParam[this.projectionKey].map === "lambert") {
        return;
      }
      this.projectionParam[this.projectionKey].map = "tm";
      this.checkRadio = "public";
    },
    changeKeiParam() {
      this.projectionParam[
        this.projectionKey
      ].origin = this.projectionProjParam[
        this.projectionParam.projection.kei
      ].origin;
      this.projectionParam[this.projectionKey].scale = this.projectionProjParam[
        this.projectionParam.projection.kei
      ].scale;
      this.projectionParam[this.projectionKey][
        "false_ne"
      ] = this.projectionProjParam[this.projectionParam.projection.kei][
        "false_ne"
      ];
    },
    changeZoneParam() {
      this.projectionParam[
        this.projectionKey
      ].origin = this.projectionProjParam[
        this.projectionParam.projection.zone
      ].origin;
      this.projectionParam[this.projectionKey].scale = this.projectionProjParam[
        this.projectionParam.projection.zone
      ].scale;
      this.projectionParam[this.projectionKey][
        "false_ne"
      ] = this.projectionProjParam[this.projectionParam.projection.zone][
        "false_ne"
      ];
    },
    changeTerrParam() {
      this.projectionParam[this.projectionKey].a = this.projectionProjParam[
        this.projectionParam.projection.terr
      ].a;
      this.projectionParam[this.projectionKey].b = this.projectionProjParam[
        this.projectionParam.projection.terr
      ].b;
      this.projectionParam[this.projectionKey].rf = this.projectionProjParam[
        this.projectionParam.projection.terr
      ].rf;
    },
    errorEvent(event: boolean, index: number) {
      if (event === false) {
        this.validateError[index] = false;
      } else {
        this.validateError[index] = true;
      }
      if (index === 22) {
        if (this.projectionParam.projection.epsg === "" && event === true) {
          this.validateError[index] = false;
        } else {
          this.validateError[index] = true;
        }
      }
      if (
        this.validateError[0] == false ||
        this.validateError[1] == false ||
        this.validateError[2] == false ||
        this.validateError[3] == false ||
        this.validateError[4] == false ||
        this.validateError[5] == false ||
        this.validateError[6] == false ||
        this.validateError[7] == false ||
        this.validateError[8] == false ||
        this.validateError[9] == false ||
        this.validateError[10] == false ||
        this.validateError[11] == false ||
        this.validateError[12] == false ||
        this.validateError[13] == false ||
        this.validateError[14] == false ||
        this.validateError[15] == false ||
        this.validateError[16] == false ||
        this.validateError[17] == false ||
        this.validateError[18] == false ||
        this.validateError[19] == false ||
        this.validateError[20] == false ||
        this.validateError[21] == false ||
        this.validateError[22] == false
      ) {
        this.errorProjection = false;
      } else {
        this.errorProjection = true;
      }
      this.$emit("hasError", this.errorProjection);
    },
    epsgEvent(event: string) {
      this.$emit("epsgConsole", event);
    },
  },
});
